import { render, staticRenderFns } from "./AwardOrderList.vue?vue&type=template&id=54a4b176&scoped=true"
import script from "./AwardOrderList.vue?vue&type=script&lang=js"
export * from "./AwardOrderList.vue?vue&type=script&lang=js"
import style0 from "./AwardOrderList.vue?vue&type=style&index=0&id=54a4b176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4b176",
  null
  
)

export default component.exports